module.exports ={
    help_center: '帮助中心',
    go_to: '回到UPlus',
    previous_page:'上一页',
    announcement_center:'公告中心',
    welcome_to_help_center:'欢迎来到帮助中心',
    anything:'我能为你做点什么？',
    getting_started_guide:'新手教程',
    getting_started_guide_desc:'了解在UPlus如何开启加密货币交易',
    customer_service:'客服',
    customer_service_desc:'无法解决，联系人工客服',
    faq:'常见问题',
    faq_desc:'Uplus使用中常见问题的说明',
    view_all:'查看全部',
    newbies_must_read:'新手必读',
    uplus_product_introduction:'UPlus产品介绍',
    exclusive_user_introduction:'专属用户介绍',
    modify_strategy_position_description:'修改策略仓位说明',
    stop_loss_instructions:'止损说明',
    points_card_and_fuel_fee_explanation:'点卡和燃料费说明',
    announcement:'公告',
    new_user_account:'新用户开通绑定流程',
    binance_api_binding_tutorial:'币安API绑定教程',
    ouyi_api_binding_tutorial:'欧易API绑定教程',
    understanding_gold:'秒懂黄金三角套利交易',
    understand_bb_trading_in_seconds:'秒懂BB交易',
    understand_ub_trading_in_seconds:'秒懂UB交易',
    understand_grid_trading_in_seconds:'秒懂网格策略',
    understand_martingale_strategy:'秒懂马丁策略',
    tutorial_on:'欧易账户合约量化开通权限教程',
    understand_hedging_contract:'秒懂对冲合约交易',
    all_read:'全部已读',
    transaction_notification:'交易通知',
    article:'文章',
    system_notification:'系统通知',
    details:'详情',
	to_UPlus:'回UPlus'
}
